var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartFeuerSchatten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 452,
    viewBox: "0 0 250 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6016 5.5L75.4016 405C75.4016 421.4 171.902 421.4 171.902 405V0L68.6016 5.5Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M38.6016 5.5L75.5016 405C75.5016 421.4 172.002 421.4 172.002 405L202.002 0L38.6016 5.5Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.6016 5.5L75.4016 405C75.4016 421.4 171.902 421.4 171.902 405V0L68.6016 5.5Z",
    fill: "url(#paint2_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.6 451.4C173.797 451.4 215.3 428.835 215.3 401C215.3 373.164 173.797 350.6 122.6 350.6C71.4032 350.6 29.9 373.164 29.9 401C29.9 428.835 71.4032 451.4 122.6 451.4Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.6 430.6C152.644 430.6 177 417.348 177 401C177 384.653 152.644 371.4 122.6 371.4C92.5558 371.4 68.2001 384.653 68.2001 401C68.2001 417.348 92.5558 430.6 122.6 430.6Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.6 419.9C141.82 419.9 157.4 411.438 157.4 401C157.4 390.561 141.82 382.1 122.6 382.1C103.381 382.1 87.8 390.561 87.8 401C87.8 411.438 103.381 419.9 122.6 419.9Z",
    fill: "url(#paint5_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.6 412.1C133.867 412.1 143 407.131 143 401C143 394.87 133.867 389.9 122.6 389.9C111.333 389.9 102.2 394.87 102.2 401C102.2 407.131 111.333 412.1 122.6 412.1Z",
    fill: "url(#paint6_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.7 437.099C193.57 437.099 249.4 420.265 249.4 399.499C249.4 378.734 193.57 361.899 124.7 361.899C55.8301 361.899 0 378.734 0 399.499C0 420.265 55.8301 437.099 124.7 437.099Z",
    fill: "url(#paint7_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.7 421.599C165.127 421.599 197.9 411.705 197.9 399.499C197.9 387.294 165.127 377.399 124.7 377.399C84.2728 377.399 51.5 387.294 51.5 399.499C51.5 411.705 84.2728 421.599 124.7 421.599Z",
    fill: "url(#paint8_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.7 429C173.246 429 212.6 417.136 212.6 402.5C212.6 387.864 173.246 376 124.7 376C76.1542 376 36.8 387.864 36.8 402.5C36.8 417.136 76.1542 429 124.7 429Z",
    fill: "url(#paint9_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.7 418.099C153.198 418.099 176.3 411.115 176.3 402.499C176.3 393.884 153.198 386.899 124.7 386.899C96.2022 386.899 73.1001 393.884 73.1001 402.499C73.1001 411.115 96.2022 418.099 124.7 418.099Z",
    fill: "url(#paint10_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 120.278,
    y1: 88.5202,
    x2: 120.278,
    y2: 505.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 120.278,
    y1: 133.187,
    x2: 120.278,
    y2: 413.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 120.278,
    y1: 228.521,
    x2: 120.278,
    y2: 508.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D99A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.61 401) scale(92.6663 50.4087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.61 401) scale(54.423 29.6051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.61 401) scale(34.8112 18.9366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.61 401) scale(20.4446 11.1215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.655 399.487) scale(124.701 37.6012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.655 399.487) scale(73.2367 22.0832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.655 402.488) scale(87.8862 26.5005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.655 402.487) scale(51.6158 15.5638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartFeuerSchatten);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-rakete-start-feuer-schatten.f1471003c0f705a41ff7c2d04075a801.svg";
export { ForwardRef as ReactComponent };